import React, { Component, Fragment } from 'react'
import { Query } from 'react-apollo'

import { SELF_QUERY } from '../../queries'

import Hero from '../../components/Hero/'
import Sentence from '../../components/Sentence/'
import Modules from '../../containers/Modules/'
import Loader from '../../components/Loader'
import Error from '../../components/Error'
import FullScreenCTA from '../../components/FullScreenCTA/'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import small from '../../assets/hero/dashboard/hero-small.jpg'
import medium from '../../assets/hero/dashboard/hero-medium.jpg'
import large from '../../assets/hero/dashboard/hero-large.jpg'
import retina from '../../assets/hero/dashboard/hero-retina.jpg'
import ctaBackground from '../../assets/cta/fairtrade.jpg'
import mobileImage from '../../assets/cta/faitrade-mobile.jpg'

class Dashboard extends Component {
  render() {
    return (
      <Fragment>
        <Hero
          small={small}
          medium={medium}
          large={large}
          retina={retina}
          title="Dashboard"
          text="Service to the Boon"
        />
        <Query query={SELF_QUERY}>
          {({ loading, error, data }) => {
            if (loading) return <Loader from="25%" to="100%" fixed />
            if (error) return <Error error="de gebruikersgegevens" />
            const { self } = data
            return (
              <Fragment>
                <Sentence text={`Welkom terug, ${self.firstName}!`} />
                <Modules
                  permissions={self.permissions}
                  role={self.role}
                  delivery={this.props.delivery}
                  portalOrder={this.props.portalOrder}
                  order={this.props.order}
                  errors={this.props.errors}
                  messages={this.props.messages}
                  servicePackage={this.props.servicePackage}
                  nextDeliveryDate={this.props.nextDeliveryDate}
                  suspended={this.props.suspended}
                />
              </Fragment>
            )
          }}
        </Query>
        <FullScreenCTA
          title={'Kies bewust voor eerlijke koffie en thee'}
          link={{ url: 'https://kaarskoffie.nl/fairtrade', content: 'Lees meer' }}
          image={ctaBackground}
          mobileImage={mobileImage}
        >
          <h3>PAC Koffie</h3>
          <p>
            Kaars Koffie is een samenwerking aangegaan met PAC in Nicaragua. PAC is een organisatie die ervoor zorgt dat
            de kleinere boeren mee kunnen handelen op de wereldmarkt. PAC helpt deze boeren om aan de eisen van het Fair
            Trade keurmerk te voldoen.
          </p>
          <h3>Tea Brothers</h3>
          <p>
            TeaBrothers ontwikkelt projecten met Fair Tea Foundation om de omstandigheden voor werknemers op
            theeplantages in Sri Lanka te verbeteren. Deze onafhankelijke non-profit organisatie stelt de werknemers
            centraal.
          </p>
        </FullScreenCTA>
      </Fragment>
    )
  }
}

export default withHeaderFooter(Dashboard, 'big')



// WEBPACK FOOTER //
// ./src/views/Dashboard/index.js